import {FC, useState, createContext, useContext, useMemo} from 'react'
import {
  ID,
  calculatedGroupingIsDisabled,
  calculateIsAllDataSelected,
  groupingOnSelect,
  initialListView,
  ListViewContextProps,
  groupingOnSelectAll,
  WithChildren,
} from '../../../../../../_metronic/helpers'
import {useQueryResponse, useQueryResponseData} from './QueryResponseProvider'
import {useLocation} from 'react-router-dom'

const ListViewContext = createContext<ListViewContextProps>(initialListView)

const ListViewProvider: FC<WithChildren> = ({children}) => {
  const [selected, setSelected] = useState<Array<ID>>(initialListView.selected)
  const [itemIdForUpdate, setItemIdForUpdate] = useState<any>(initialListView.itemIdForUpdate)
  const [selectedLabel, setSelectedLabel] = useState<any>('')
  const {isLoading} = useQueryResponse()
  const data = useQueryResponseData()
  const {pathname} = useLocation()
  const modifyData = useMemo(
    () =>
      pathname === '/apps/plastic-credits/audited'
        ? data
        : (data?.length &&
            data?.filter(
              (item: any) => item.id && item.status === 'CREATED' && item.auditorName
            )) ||
          [],
    [data, pathname]
  )
  // const modifyData: any = data?.filter((item: any) => item.id && item.status === 'CREATED') || []
  const disabled = useMemo(
    () => calculatedGroupingIsDisabled(isLoading, modifyData),
    [isLoading, modifyData]
  )
  const isAllSelected = useMemo(
    () => calculateIsAllDataSelected(modifyData, selected),
    [modifyData, selected]
  )
  return (
    <ListViewContext.Provider
      value={{
        selected,
        itemIdForUpdate,
        selectedLabel,
        setItemIdForUpdate,
        setSelectedLabel,
        disabled,
        isAllSelected,
        onSelect: (id: ID) => {
          groupingOnSelect(id, selected, setSelected)
        },
        onSelectAll: () => {
          groupingOnSelectAll(isAllSelected, setSelected, modifyData)
        },

        clearSelected: () => {
          setSelected([])
        },
      }}
    >
      {children}
    </ListViewContext.Provider>
  )
}

const useListView = () => useContext(ListViewContext)

export {ListViewProvider, useListView}
